import axios from 'axios'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'

export interface ResetPasswordVariables {
  username: string
  appName: string
}

/**
 * Requests a password reset mail for the given username. This endpoint is called from the
 * public reset-password page, so it is called with plain axios instead of authFetch.
 */
export const resetPassword = async ({ username, appName }: ResetPasswordVariables): Promise<ApiResult<void, AuthFetchError | Error>> => {
  try {
    const data = new FormData()
    data.append('username', username)
    if (appName) data.append('app', appName)

    const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/users/password-reset`, data)

    if (response.status === StatusCodes.NO_CONTENT) {
      return new ApiResult<void, AuthFetchError | Error>()
    }
    return new ApiResult<void, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<void>(error)
  }
}
